/**
 * This function is only used to decouple date from the ISO format string
 * e.g. it will return 2022-02-02 from 2022-02-02T00:00:00.0000 string
 * or null
 * @param {string} date
 * @returns {string | null}
 */
const splitDateFromISOString = (date: string): string | null => {
  return date ? new Date(date).toISOString().split("T")[0] : null;
};

export default splitDateFromISOString;
